export default __webpack_public_path__ + "static/media/custom-table.eb51e9d2.less";